var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid py-3"},[_c('h3',{staticClass:"font-weight-bold text-primary mb-3"},[_vm._v("Front desk")]),_vm._v(" "),_c('attendance-desk')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }